export { default as HomeSolidIcon } from './HomeSolidIcon';
